<template>
    <div>
        <v-card>
            <v-card-title>{{$t("welcome")}} {{$store.state.name}}</v-card-title>
            <v-card-text>
                The requested page does not exist
            </v-card-text>            
        </v-card>
    </div>
</template>

<script>

export default
{    
}

</script>